// extracted by mini-css-extract-plugin
export default {"button":"Button_button__CpODN","alt":"Button_alt__TY+db"};